import React, { useContext } from 'react';

import ActionButton from './ActionButton';
import Hyperlink from '@ad-scripts/presentation/components/common/icons/hyperlink';
import { SidekickThreadEditorContext } from 'src/presentation/components/pages/sidekick/threads/SidekickThreadEditorContext';
import useOpenThread from 'src/presentation/components/pages/sidekick/threads/hooks/useOpenThread';

const PivotButton = ({ id, name }: { id: number; name: string }) => {
  const { root } = useContext(SidekickThreadEditorContext);
  const { handleOpenThread } = useOpenThread({ root });

  const onClick = () => {
    handleOpenThread(id.toString());
  };

  return (
    <ActionButton onClick={onClick} title={name}>
      <Hyperlink width="16" alt={name} />
    </ActionButton>
  );
};

export default PivotButton;
